export default __webpack_public_path__ + "static/media/flag-wallis-and-futuna.671d04c2.svg";